import React, { useEffect, useState } from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import MainApp from "views/main-app";

import Login from "views/login/login.js";
import PrivateRoute from "util/private-route.js";
import "./scss/style.scss";
import {
  USER_STORAGE,
  ROLE_USER,
  isEspotive,
  BRANCH_STORAGE,
  isBoot,
  getUserLogged,
} from "./constants";
import UsersClient from "views/client/users/users-client";
import { useSelector } from "react-redux";
import { selectRole } from "reducer/login/login-user";
import Page404 from "views/404/Page404";
import Managerial from "views/client/managerial/managerial";
import ReviewsClient from "views/client/reviews/reviews-client";
import ReviewsClientUser from "views/client/reviews/reviews-client-user";
import RankingClient from "views/client/ranking/ranking-client";
import LoadControlClient from "views/client/load-control/load-control-client";
import Planning from "views/client/planning/planning";
import TrainningClient from "views/client/trainning/trainning-client";
import PlanClientUser from "views/client/planning/planning-client-user";
import LoadControlClientUser from "views/client/load-control/load-control-client-user";
import ManagerialUser from "views/client/managerial/managerial-user";
import UsersClientTab from "views/client/users/users-client-tab";
import BranchClient from "views/client/branches/branches-client ";
import ManagerialAqua from "views/client/managerial/managerial-aqua";
import ManagerialAquaUser from "views/client/managerial/managerial-aqua-user";
import ReviewsClientAqua from "views/client/reviews/reviews-client-aqua";
import TrainningBootAqua from "views/client/trainning/trainning-boot-aqua";
import FormTrainningBootAqua from "views/client/trainning/trainning-drawer-boot-aqua";
import ReviewsClientUserAqua from "views/client/reviews/reviews-client-user-aqua";

const RouterApp = (props) => {
  const [roleRedux, setRoleRedux] = useState(useSelector(selectRole));
  const [branchType, setBranchType] = useState(getTypeBranch());

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { role } = JSON.parse(localStorageItem);
      if (roleRedux == "" || role != roleRedux) {
        setRoleRedux(role);
      }
    }
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      const updatedType = getTypeBranch();
      setBranchType(updatedType);
    };

    window.addEventListener("storage", handleStorageChange);

    const interval = setInterval(() => {
      const currentType = getTypeBranch();
      setBranchType((prev) => (prev !== currentType ? currentType : prev));
    }, 1000);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  function getNavegateApp() {
    let navegateApp =
      null == roleRedux || "" == roleRedux
        ? "/login"
        : "/app/client/managerial";

    return navegateApp;
  }
  setTimeout(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);

    if (localStorageItem != null) {
      const { role } = JSON.parse(localStorageItem);
      if (roleRedux == "" || role != roleRedux) {
        setRoleRedux(role);
      }
    }
  }, 1000);

  const getManagerial = () => {
    if (isEspotive()) {
      return roleRedux == ROLE_USER ? <ManagerialUser /> : <Managerial />;
    } else {
      return roleRedux == ROLE_USER ? (
        isBoot() == true ? (
          <FormTrainningBootAqua user={getUserLogged()} />
        ) : (
          <ManagerialAquaUser />
        )
      ) : (
        <ManagerialAqua />
      );
    }
  };

  const getReview = () => {
    if (isEspotive()) {
      return roleRedux == ROLE_USER ? <ReviewsClientUser /> : <ReviewsClient />;
    } else {
      return roleRedux == ROLE_USER ? (
        <ReviewsClientUserAqua />
      ) : (
        <ReviewsClientAqua />
      );
    }
  };

  function getTypeBranch() {
    const localStorageItemBranch = localStorage.getItem(BRANCH_STORAGE);
    if (localStorageItemBranch != null) {
      const { type } = JSON.parse(localStorageItemBranch);
      return type;
    } else {
      return "ESPORTIVO";
    }
  }
  const getTraining = () => {
    if (isEspotive()) {
      return <TrainningClient />;
    } else {
      return <TrainningBootAqua />;
    }
  };
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route
            path="/app"
            element={<Navigate to={getNavegateApp()} replace />}
          />

          <Route
            path="/app/client"
            element={<Navigate to={getNavegateApp()} replace />}
          />
          <Route exact path="/app" element={<PrivateRoute />}>
            <Route
              path="/app/client/users"
              element={<MainApp component={<UsersClientTab />} />}
            />
            <Route
              path="/app/client/branches"
              element={<MainApp component={<BranchClient />} />}
            />
            <Route
              path="/app/client/planning"
              element={
                <MainApp
                  component={
                    roleRedux == ROLE_USER ? <PlanClientUser /> : <Planning />
                  }
                />
              }
            />
            <Route
              path="/app/client/trainning"
              element={<MainApp component={getTraining()} />}
            />
            <Route
              path="/app/client/load-control"
              element={
                <MainApp
                  component={
                    roleRedux == ROLE_USER ? (
                      <LoadControlClientUser />
                    ) : (
                      <LoadControlClient />
                    )
                  }
                />
              }
            />
            <Route
              path="/app/client/ranking"
              element={<MainApp component={<RankingClient />} />}
            />

            <Route
              path="/app/client/reviews"
              element={<MainApp component={getReview()} />}
            />

            <Route
              path="/app/client/managerial"
              element={<MainApp component={getManagerial()} />}
            />
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Login />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default RouterApp;
